import { SafeStorage } from './safe-storage';

/**
 * Whether the signed-in user has the native Picaggo app, as reported by the
 * sign-in API (pwa_sign_in → has_native_app / native_app_platform, read from
 * their latest iOS/Android row in login_tbl).
 *
 * Use it to hide get-the-app prompts. Only "yes" is trusted: no answer (guest,
 * signed in before the API returned it, storage cleared) means "don't know",
 * and callers should treat that as "no" and keep showing the prompt.
 *
 * Cleared with everything else on sign-out (SafeStorage.clear()).
 */
const HAS_APP_KEY = 'hasNativeApp';
const APP_PLATFORM_KEY = 'nativeAppPlatform';

export function rememberNativeApp(res: any): void {
  if (typeof res?.has_native_app !== 'boolean') return; // older API: leave as unknown
  SafeStorage.setItem(HAS_APP_KEY, res.has_native_app ? '1' : '0');
  if (res.native_app_platform) {
    SafeStorage.setItem(APP_PLATFORM_KEY, String(res.native_app_platform));
  } else {
    SafeStorage.removeItem(APP_PLATFORM_KEY);
  }
}

export function hasNativeApp(): boolean {
  return SafeStorage.getItem(HAS_APP_KEY) === '1';
}

/** 'ios' | 'android' | null — the platform the user last used the app on. */
export function nativeAppPlatform(): string | null {
  return SafeStorage.getItem(APP_PLATFORM_KEY);
}
